var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.block.versionId.length === 0)?_c('div',[_vm._v(" No sop-block selected ")]):_c(_vm.componentName,{tag:"component"})}
var staticRenderFns = []

export { render, staticRenderFns }